"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M8 10H12",
    stroke: props.foregroundColor,
    strokeWidth: "0.5",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M8 12H13",
    stroke: props.foregroundColor,
    strokeWidth: "0.5",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    d: "M8 14H11",
    stroke: props.foregroundColor,
    strokeWidth: "0.5",
    strokeLinecap: "round"
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M18.3536 11.6466L14.3536 7.64658L14.3531 7.64611C14.3428 7.63589 14.3321 7.62633 14.3212 7.61717C14.3178 7.61439 14.3141 7.61161 14.3106 7.60869C14.3026 7.60236 14.2945 7.59625 14.2862 7.59044C14.282 7.58753 14.2779 7.58461 14.2736 7.58181C14.2648 7.57608 14.2559 7.57069 14.2468 7.56558C14.2431 7.56347 14.2395 7.56117 14.2357 7.55914C14.2236 7.55268 14.2113 7.54674 14.1987 7.54133C14.1936 7.53911 14.1884 7.53722 14.1832 7.53517C14.1749 7.53186 14.1666 7.52875 14.1579 7.52592C14.1521 7.524 14.1463 7.52214 14.1404 7.52036C14.1307 7.51758 14.121 7.51508 14.1111 7.51283C14.1068 7.51186 14.1026 7.51064 14.0982 7.50978C14.0843 7.507 14.0701 7.50492 14.0558 7.50331C14.0515 7.50283 14.0471 7.50253 14.0428 7.50217C14.031 7.50117 14.0193 7.50057 14.0074 7.50039C14.0049 7.50039 14.0025 7.5 13.9999 7.5H6C5.86739 7.5 5.74021 7.55268 5.64645 7.64645C5.55268 7.74022 5.5 7.86739 5.5 8V16.0001C5.5 16.1327 5.55268 16.2599 5.64645 16.3537C5.74021 16.4475 5.86739 16.5001 6 16.5001H14C14.0167 16.5001 14.0333 16.4992 14.0497 16.4976C14.059 16.4967 14.068 16.495 14.0771 16.4936C14.084 16.4925 14.091 16.4918 14.0979 16.4904C14.1095 16.4881 14.1208 16.485 14.1322 16.4819C14.1364 16.4807 14.1408 16.4799 14.145 16.4786C14.1568 16.4751 14.1682 16.4707 14.1796 16.4664C14.1834 16.4649 14.1872 16.4637 14.1909 16.4622C14.2021 16.4576 14.2127 16.4524 14.2233 16.4471C14.2273 16.4451 14.2314 16.4434 14.2353 16.4413C14.2455 16.4357 14.2552 16.4297 14.2649 16.4237C14.2691 16.4211 14.2734 16.4188 14.2775 16.416C14.2874 16.4094 14.2969 16.4021 14.3063 16.3948C14.3098 16.3921 14.3135 16.3896 14.317 16.3868C14.3299 16.3762 14.3422 16.3651 14.3539 16.3535L18.3537 12.3538C18.4001 12.3073 18.4369 12.2522 18.4621 12.1915C18.4872 12.1309 18.5001 12.0658 18.5001 12.0002C18.5001 11.9345 18.4871 11.8695 18.462 11.8088C18.4369 11.7481 18.4 11.693 18.3536 11.6466ZM16 13.0001C15.8022 13.0001 15.6089 12.9415 15.4444 12.8316C15.28 12.7217 15.1518 12.5655 15.0761 12.3828C15.0004 12.2001 14.9806 11.999 15.0192 11.805C15.0578 11.6111 15.153 11.4329 15.2929 11.293C15.4327 11.1532 15.6109 11.0579 15.8049 11.0194C15.9989 10.9808 16.2 11.0006 16.3827 11.0763C16.5654 11.1519 16.7216 11.2801 16.8315 11.4446C16.9414 11.609 17 11.8024 17 12.0001C17 12.2654 16.8946 12.5197 16.7071 12.7072C16.5196 12.8948 16.2652 13.0001 16 13.0001Z",
    fill: props.foregroundColor
  }));
};

Label.defaultProps = {
  altText: "ArrowUp",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Label.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Label;
exports.default = _default;